function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/nonIterableRest.js
// module id = 3T7U
// module chunks = 0